const url = 'v1/pub/boletos/:id';

const applet = '/p/boletos';

const view = `${applet}/download/:id`;

const DownloadStatus = {
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export { url, applet, view, DownloadStatus };
